import React from 'react';
import { motion } from 'framer-motion';
import setup from '../../assets/data/setup.json';

function HeroStats() {
  const { stats } = setup;

  const metrics = [
    { value: `${stats.productionIntegrations}+`, label: 'Third-party Integrations' },
    { value: `${stats.enterpriseApps}`, label: 'Production Systems' },
    { value: `${stats.yearsExperience}+`, label: 'Years' },
    { value: `${stats.featuresDelivered}+`, label: 'Major Features' },
    { value: `${stats.productionDeployments}+`, label: 'Deployments' },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.25 }}
      className="grid grid-cols-2 sm:grid-cols-5 gap-3 sm:gap-4 mb-8"
    >
      {metrics.map((metric) => (
        <div
          key={metric.label}
          className="ui-card ui-card-lift p-3 sm:p-4 text-center"
        >
          <p className="text-lg sm:text-xl font-semibold text-ink tabular-nums tracking-tight">
            {metric.value}
          </p>
          <p className="text-[10px] sm:text-[11px] text-ink-muted mt-0.5 leading-tight">
            {metric.label}
          </p>
        </div>
      ))}
    </motion.div>
  );
}

export default HeroStats;
